import gql from 'graphql-tag';
import { FooterDisclaimerItemFragment, ImageFragment, KeyValueDataFragment } from './fragments';

export const VcxLandingPageQuery = gql`
	query VcxLandingPage {
		allVcxLandingPage {
			_id
			vcxFundDetailsUpdateAsOfDate
			vcxPortfolioDescription: vcxPortfolioDescriptionRaw
			vcxPortfolioHoldings {
				...KeyValueDataFragment
			}
			vcxSectorBreakdown {
				...KeyValueDataFragment
			}
			vcxPrivatePublicBreakdown {
				...KeyValueDataFragment
			}
			vcxPortfolioSectionDisclaimer
			vcxPerformanceData {
				...KeyValueDataFragment
			}
			vcxPerformanceDisclaimer
			vcxFeaturedArticles {
				slug {
					current
				}
				title
				abstract
				date
			}
			vcxFeaturedPodcasts {
				title
				description
				applePodcastLink
				spotifyPodcastLink
				podcastImage {
					...ImageFragment
				}
			}
		}
	}
	${KeyValueDataFragment}
	${ImageFragment}
`;

export const VcxLandingPageFooterQuery = gql`
	query VcxLandingPageFooter {
		allVcxLandingPage {
			vcxFooterDisclaimers {
				...FooterDisclaimerItemFragment
			}
		}
	}
	${FooterDisclaimerItemFragment}
`;
